import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';

import './index.scss';
import '../scss/public.scss';
import Color from '@tool/color';
import { newRate } from '@tool/index';
import moIndex from '../../store/index';
import moCategory from './store';
import Empty from '@comp/empty/index';
import moUser from '@store/user';

interface IProps {}
interface IState {}

// 涨薪率 - 职能类型涨薪率
const CategoryTypeRate = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isLogin } = moUser;
  const { industry, isMock } = moIndex;
  const { titleList, list, overview, labels, maxValue } = moCategory;
  const descArr = [
    "统计说明：在相同行业、城市组合下，计算各职能月度薪酬的中位数，然后计算月度薪酬的同比变化率，最后计算各统计周期下的变化率均值，即为涨薪率",
    "*此处为不区分城市的涨薪率",
  ];

  const filterWidth = (value: any) => {
    let newValue = 3;
    if (isNaN(value)) newValue = 3;
    if (value === null || value === '' || value === undefined) newValue = 3;
    if (value === 0) newValue = 3;
    if (maxValue !== 0 && round(Math.abs(value) * 100, 0) !== 0) {
      newValue = round(Math.abs(value / maxValue) * 100, 0);
    }
    else newValue = 3;
    return newValue;
  };

  const filterWidthBak = (value: any) => {
    let newValue = 3;
    if (isNaN(value)) newValue = 3;
    if (value === null || value === '' || value === undefined) newValue = 3;
    if (value === 0) newValue = 3;
    if (round(Math.abs(value) * 100, 0) > 5) newValue = round(Math.abs(value) * 100, 0);
    else newValue = 3;
    return newValue;
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="category-type-rate_10">
      <p className="one-11">
        <strong>职能类型涨薪率</strong>
        <span className="tag-02">{industry.name}</span>
      </p>
      <p className="one-13 one-166" style={{ color: '#878787' }}>
        {descArr.map((text: any, ix: number) => (
          <span key={ix}>{text}</span>
        ))}
      </p>

      {!isEmpty(list) ? (
        <section className="box-11" style={{ marginTop: '20px' }}>
          <section className="box-13">
            <section className="chart-title_03" style={{ paddingRight: '10px' }}>
              {labels.map((item: any, idx: number) => (
                <p key={idx} className="line-03" style={{ marginRight: '10px' }}>
                  <strong>{newRate(item?.change_rate)}</strong>
                  <span style={{ lineHeight: 1.3 }}>{item?.date}涨薪率</span>
                </p>
              ))}
            </section>
            <section className={[
              "box-166",
              !isMock ? '' : 'mock-100',
            ].join(' ')}>
              <p className="title-166">
                {titleList.map((item: any, index: number) => (
                  <span key={index}>{item}</span>
                ))}
              </p>
              <section className="table-166">
                {list.map((item: any, index: number) => (
                  <section className="line-166" key={index}>
                    <span className="value-10 value-11">{item.type}</span>
                    {item.arr?.map((child: any, idx: number) => (
                      <p key={idx} className={['value-10', 'value-13'].join(' ')}>
                        <span>{newRate(child)}</span>
                        <i className={[child >= 0 ? 'up-15' : 'down-15'].join(' ')}
                          style={{
                            width: `${filterWidth(child)}%`,
                          }} />
                      </p>
                    ))}
                  </section>
                ))}
              </section>
            </section>
          </section>
          <section className="box-150">
            <strong>解读：</strong>
            <section className="box-151">
              {overview.map((text: any, index: number) => (
                <p key={index}>
                  <span className="ico-11"><b /></span>
                  <i>{text}</i>
                </p>
              ))}
            </section>
          </section>
        </section>
      ) : <Empty padding="50px 0" />}
    </section>
  );
};

export default observer(CategoryTypeRate);
